<template>
  <el-container class="home">
    <el-header
      class="header"
      height="80px"
      :style="{ background: $store.state.app.themeColor }"
    >
      <Header></Header>
    </el-header>
    <el-container>
      <el-aside width="220px">
        <Aside class="aside"></Aside>
      </el-aside>
      <el-main class="main">
        <el-container class="body">
          <el-header height="40px">
            <BreadCrumb></BreadCrumb>
          </el-header>
          <el-main class="views">
            <router-view></router-view>
          </el-main>
          
        </el-container>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Header from "@/components/layout/Header";
import Aside from "@/components/layout/Aside";
import BreadCrumb from "@/components/layout/BreadCrumb";
export default {
  name: "index",
  components: {
    Header,
    Aside,
    BreadCrumb,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.home {
  height: 100%;
 
  .header {
    height: 100%;
  }
  .aside {
    height: 100%;
  }
  .main {
    padding: 0;
    .body {
      height: 100%;
      .breadcrumb {
        line-height: 40px;
      }
      .views {
        background: #F0F0F0;
        padding: 10px;
      }
    }
  }
}
</style>
<style>
 .el-card__body{
  padding-top: 10px !important;
  padding-bottom: 0px !important;
}
.selectCriteria .el-form-item {
    margin-bottom: 12px !important;
}

</style>